import React from 'react';
import ListCell, { ListCellProps } from './list-cell';

// Growable/validated form-input cells anchor to the row's top instead of its vertical center
const FormListCell: React.FC<ListCellProps> = (props) => <ListCell verticalAlign="top" {...props} />;

export default FormListCell;
